import React from 'react';
import PropTypes from 'prop-types';
import LinearValueProgress from './LinearValueProgress';
import Snackbar from '@material-ui/core/Snackbar';
import { darken, withStyles } from '@material-ui/core/styles';
import { createStyles, SnackbarContent } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { BACKGROUND_DARK, BACKGROUND_WHITE, LIGHT_GREY_COLOR } from '../../const/color-const';

const ALERT_WIDTH = '320px';

const styles = createStyles((theme) => ({
  additionalBar: {
    display: 'flex',
    justifyContent: 'center',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    zIndex: 100,
    width: ALERT_WIDTH,
    color: theme.palette.type === 'light' ? 'black' : 'white',
    background: theme.palette.type === 'light' ? BACKGROUND_WHITE : darken(BACKGROUND_DARK, 0.3),
    border: `1px solid ${LIGHT_GREY_COLOR}`,
    boxShadow: 'none',
    bottom: '90px',
    [theme.breakpoints.up('sm')]: {
      bottom: '110px',
    },
  },
  centered: {
    position: 'fixed',
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
    [theme.breakpoints.up('md')]: {
      left: 'calc(50% + 128px)',
    },
  },
}));

const LoadingSnackbar = (props) => {
    const { progress, label, classes, downloadFile, large } = props;
    const isOpen = (progress > 0 || progress === 0) && progress !== 100;
    const renderDownloadBar = downloadFile && isOpen;
    
    const renderMessage = () => {
      switch (true) {
        case (renderDownloadBar && progress < 1):
          return <FormattedMessage
            id="report.title.preparing-file"
            defaultMessage="Preparing your file"
          />;
        case (renderDownloadBar):
          return <FormattedMessage
            id="downloading.file"
            defaultMessage="Downloading file"
          />;
        case (large):
          return <FormattedMessage
            id="large.data"
            defaultMessage="Downloading large amounts of data"
          />;
        default:
          return <FormattedMessage
            id="Preparing.data"
            defaultMessage="Fetching data"
          />;
      }
    };
    
    return (
      <>
        <Snackbar className={classes.centered}
                  open={isOpen}>
          <LinearValueProgress
            label={label}
            value={progress}
          />
        </Snackbar>
    
        {isOpen && <SnackbarContent
          className={`${classes.additionalBar} ${classes.centered}`}
          message={renderMessage()} />}
      </>
    );
  }
;

LoadingSnackbar.defaultProps = {
  downloadFile: false,
  large: false,
};

LoadingSnackbar.propTypes = {
  progress: PropTypes.number,
  label: PropTypes.object,
  classes: PropTypes.object,
  downloadFile: PropTypes.bool,
};

export default withStyles(styles)(LoadingSnackbar);